module.exports = __webpack_public_path__ + "static/img/active1.bf8c06bb.png";